import { roleConstants } from "../../../constants/role.constants";

export function role(state = {}, action) {

  switch (action.type) {

    case roleConstants.GET_ALL_BY_ORGANIZATION_REQUEST:
        case roleConstants.UPDATE_ROLES_REQUEST:
      return {...state,
        loading: true,
      };
    case roleConstants.GET_ALL_BY_ORGANIZATION_SUCCESS:
        case roleConstants.UPDATE_ROLES_SUCCESS:
      return {...state,
        loading: false,
        roles:action.roles, 
        modules:action.modules,
      };
      case roleConstants.GET_ALL_BY_ORGANIZATION_FAILURE:
        case roleConstants.UPDATE_ROLES_FAILURE:
      return {...state,
        loading: false,
        error: action.error
      };



      case roleConstants.CREATE_ROLE_REQUEST:
      return {...state,
        loading: true,
      };
    case roleConstants.CREATE_ROLE_SUCCESS:
      return {...state,
        loading: false,
        updatedRole: action.role
      };
    case roleConstants.CREATE_ROLE_FAILURE:
      return {...state,
        loading: false,
        error: action.error
      };

    case roleConstants.DELETE_ROLE_REQUEST:
      return {...state,
        loading: true,
      };
    case roleConstants.DELETE_ROLE_SUCCESS:
      return {...state,
        loading: false,
        deletedRoleId: action.roleId
      };
    case roleConstants.DELETE_ROLE_FAILURE:
      return {...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
